import { useCallback, useContext } from 'react';
import _get from 'lodash/get';
import _find from 'lodash/find';
import { formatListData, AjaxContext, AppContext, UserContext } from 'commons-ui';

import { PAGE_NAMES, MISCELLANEOUS_RESOURCES, ACTION } from 'constant';

import { FraudFilters, pageDetailsType } from '../../types';

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const { permissionsConfig } = useContext(UserContext);
	const {
		app: { appName }
	} = useContext(AppContext);

	const getConfiscationAndRefundRequestInBulk = useCallback(
		async (props: { pageDetails: pageDetailsType; filters?: FraudFilters }) => {
			const { pageDetails, filters } = props;
			const permission = _find(permissionsConfig, { actionName: ACTION.getConfiscationAndRefundRequestInBulk });
			const result = await postData({
				endpoint: `/dashboard/getConfiscationAndRefundRequestInBulk/${PAGE_NAMES.miscellaneous}-${MISCELLANEOUS_RESOURCES.confiscationAndRefund}-getConfiscationAndRefundRequestInBulk`,
				queryParams: {
					appName
				},
				body: {
					...(filters || {}),
					limit: pageDetails.pageSize,
					pageId: pageDetails.pageNo - 1
				},
				customHeaders: {
					isMasked: permission?.isMasked || false
				}
			});

			return {
				rowCount: 1000,
				data: formatListData(_get(result, ['data', 'data'], [])),
				nextPageId: _get(result, ['data', 'nextPageId'], null)
			};
		},
		[]
	);

	return {
		getConfiscationAndRefundRequestInBulk
	};
};

export default useService;
